import React from 'react'

import ListPlaceholder from 'src/ui/List/ListPlaceholder'
import MyCourseSkeleton from 'src/pages/MyCourse/MyCourseSkeleton'

const MyCoursePlaceholder = () => {
  return (
    <MyCourseSkeleton listSection={<ListPlaceholder includesTitle={false} />} />
  )
}

export default MyCoursePlaceholder
